import React from 'react'
import {
  Box,
  Typography as MuiTypography,
  type TypographyProps as MuiTypographyProps,
  Tooltip,
} from '@mui/material'

import './Typography.scss'

export interface TypographyProps extends MuiTypographyProps {
  maxChars?: number
  truncate?: boolean
  required?: boolean
}

const Typography = React.forwardRef<HTMLElement, TypographyProps>(
  ({ children, maxChars = 100, truncate = false, required = false, className, ...props }, ref) => {
    const isStringContent = typeof children === 'string' || typeof children === 'number'
    const contentString = isStringContent ? String(children) : ''
    const shouldTruncate =
      truncate && isStringContent && maxChars && contentString.length > maxChars
    const displayContent = shouldTruncate ? `${contentString.slice(0, maxChars)}...` : children

    const classNames = [
      'internal-typography',
      shouldTruncate && 'internal-typography--truncated',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    const typographyElement = (
      <MuiTypography ref={ref} className={classNames} {...props}>
        {displayContent}
        {required && (
          <Box component='span' className='internal-typography__required'>
            *
          </Box>
        )}
      </MuiTypography>
    )

    if (shouldTruncate) {
      return <Tooltip title={contentString}>{typographyElement}</Tooltip>
    }

    return typographyElement
  },
)

Typography.displayName = 'Typography'

export default Typography
